module.exports = __webpack_public_path__ + "img/float-search.dd411fe1.svg";